import Maps from'../vendors/fc-maps/src/chart/maps';export{Maps};export default{name:'maps',type:'package',requiresFusionCharts:!0,extension:a=>a.addDep(Maps)};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/maps/index.js
// module id = null
// module chunks = 